import React from 'react';
export const AutoLoginLayout = props => {
    const { children } = props;
    return React.createElement("div", { className: 'd-flex align-items-center justify-content-center vh-100 vw-100' }, children);
};
